(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fec-content-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'fec-shopify-forms-polish';
    const css = `
      :host {
        --container-max-w: min(100%, 940px) !important;
        --inline-container-max-width: min(100%, 940px) !important;
        --inline-form-alignment: stretch !important;
        --app-embed-width: 100% !important;
        --app-embed-padding-x: 0px !important;
        display: block !important;
        width: 100% !important;
        box-sizing: border-box !important;
        font-family: Inter, Arial, Helvetica, sans-serif !important;
        color: #15213A !important;
      }

      *, *::before, *::after {
        box-sizing: border-box !important;
      }

      form,
      [role="form"],
      .form,
      .form-container,
      .forms-form,
      .shopify-form,
      main,
      section {
        width: min(100%, 940px) !important;
        max-width: 940px !important;
        margin-left: auto !important;
        margin-right: auto !important;
        padding-left: clamp(22px, 4vw, 44px) !important;
        padding-right: clamp(22px, 4vw, 44px) !important;
        font-family: Inter, Arial, Helvetica, sans-serif !important;
      }

      h1, h2, h3, legend {
        color: #0D1B2A !important;
        font-family: Georgia, 'Times New Roman', serif !important;
        font-weight: 400 !important;
        letter-spacing: -0.02em !important;
        line-height: 1.12 !important;
      }

      fieldset,
      form,
      [role="group"],
      [role="radiogroup"],
      [data-testid="app-router"],
      ul,
      ol,
      [class*="container"],
      [class*="Container"],
      [class*="question"],
      [class*="Question"],
      [class*="layout"],
      [class*="Layout"],
      [class*="choice"],
      [class*="Choice"],
      [class*="option"],
      [class*="Option"],
      [class*="field"],
      [class*="Field"] {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      fieldset,
      [role="group"],
      [role="radiogroup"] {
        min-width: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        border: 0 !important;
      }

      legend,
      fieldset > label,
      [role="group"] > label,
      [role="radiogroup"] > label {
        max-width: 100% !important;
        text-align: left !important;
      }

      p, label, span, div {
        font-family: Inter, Arial, Helvetica, sans-serif !important;
      }

      label,
      legend,
      .label,
      [class*="label"] {
        color: #15213A !important;
        font-size: 14px !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        letter-spacing: 0.01em !important;
      }

      input:not([type="radio"]):not([type="checkbox"]),
      textarea,
      select {
        width: 100% !important;
        max-width: 100% !important;
        min-height: 46px !important;
        padding: 12px 14px !important;
        color: #15213A !important;
        background: #FFF8EC !important;
        border: 1px solid rgba(196, 154, 87, 0.55) !important;
        border-radius: 14px !important;
        box-shadow: inset 0 0 0 1px rgba(13, 27, 42, 0.03) !important;
        font-family: Inter, Arial, Helvetica, sans-serif !important;
        font-size: 16px !important;
        line-height: 1.35 !important;
      }

      textarea {
        min-height: 140px !important;
        padding-top: 38px !important;
        resize: vertical !important;
      }

      textarea + label,
      textarea ~ label {
        top: 10px !important;
        padding: 0 3px !important;
        background: #FFF8EC !important;
        line-height: 1.2 !important;
        pointer-events: none !important;
      }

      input[type="radio"],
      input[type="checkbox"] {
        appearance: auto !important;
        -webkit-appearance: auto !important;
        display: inline-block !important;
        flex: 0 0 auto !important;
        width: 18px !important;
        min-width: 18px !important;
        max-width: 18px !important;
        height: 18px !important;
        min-height: 18px !important;
        max-height: 18px !important;
        margin: 2px 10px 0 0 !important;
        padding: 0 !important;
        border-radius: 999px !important;
        accent-color: #0D1B2A !important;
        box-shadow: none !important;
      }

      input[type="checkbox"] {
        border-radius: 4px !important;
      }

      label:has(input[type="radio"]),
      label:has(input[type="checkbox"]) {
        display: grid !important;
        grid-template-columns: 22px minmax(0, 1fr) !important;
        align-items: start !important;
        column-gap: 12px !important;
        width: 100% !important;
        min-height: 28px !important;
        margin: 8px 0 !important;
        padding: 4px 0 !important;
        line-height: 1.35 !important;
        white-space: normal !important;
      }

      label:has(input[type="radio"]) > span,
      label:has(input[type="radio"]) > div,
      label:has(input[type="checkbox"]) > span,
      label:has(input[type="checkbox"]) > div {
        flex: 1 1 auto !important;
        min-width: 0 !important;
      }

      div:has(> input[type="radio"]):has(> label),
      div:has(> input[type="checkbox"]):has(> label),
      li:has(> input[type="radio"]):has(> label),
      li:has(> input[type="checkbox"]):has(> label) {
        display: grid !important;
        grid-template-columns: 22px minmax(0, 1fr) !important;
        column-gap: 12px !important;
        align-items: start !important;
        width: 100% !important;
      }

      input[type="radio"] + label,
      input[type="checkbox"] + label {
        min-width: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        line-height: 1.45 !important;
        white-space: normal !important;
      }

      label:has(input[type="radio"]) input[type="radio"],
      label:has(input[type="checkbox"]) input[type="checkbox"] {
        margin-right: 0 !important;
      }

      input:not([type="radio"]):not([type="checkbox"]):focus,
      textarea:focus,
      select:focus {
        outline: 2px solid rgba(196, 154, 87, 0.45) !important;
        outline-offset: 2px !important;
        border-color: #C49A57 !important;
      }

      button[type="submit"],
      input[type="submit"],
      form button:not([aria-label*="close" i]) {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: min(100%, 280px) !important;
        min-width: 220px !important;
        min-height: 46px !important;
        margin: 16px auto 4px !important;
        padding: 14px 24px 13px !important;
        color: #FFF8EC !important;
        background: #0D1B2A !important;
        border: 1px solid #C49A57 !important;
        border-radius: 999px !important;
        box-shadow: 0 0 0 2px rgba(196, 154, 87, 0.24), 0 8px 16px rgba(14, 32, 60, 0.12) !important;
        font-family: Inter, Arial, Helvetica, sans-serif !important;
        font-size: 13px !important;
        font-weight: 800 !important;
        letter-spacing: 0.1em !important;
        line-height: 1 !important;
        text-align: center !important;
        text-transform: uppercase !important;
        cursor: pointer !important;
      }

      a {
        color: #0D1B2A !important;
        text-decoration-color: #C49A57 !important;
      }

      [class*="field"],
      [class*="Field"],
      [class*="input"],
      [class*="Input"],
      [class*="control"],
      [class*="Control"] {
        max-width: 100% !important;
      }

      [class*="error"],
      [class*="Error"] {
        color: #B3261E !important;
      }

      @media (max-width: 520px) {
        form,
        [role="form"],
        .form,
        .form-container,
        .forms-form,
        .shopify-form,
        main,
        section {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        label:has(input[type="radio"]),
        label:has(input[type="checkbox"]) {
          gap: 12px !important;
          padding-left: 2px !important;
          padding-right: 2px !important;
          font-size: 15px !important;
        }

        input[type="radio"],
        input[type="checkbox"] {
          width: 20px !important;
          min-width: 20px !important;
          max-width: 20px !important;
          height: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
        }

        button[type="submit"],
        input[type="submit"],
        form button:not([aria-label*="close" i]) {
          width: 100% !important;
          min-width: 0 !important;
          margin-top: 20px !important;
        }
      }
    `;

    const polishForm = (el) => {
      const root = el && el.shadowRoot;
      if (!root || root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
    };

    const polishAll = () => {
      document.querySelectorAll('.fec-content-page + .shopify-section[id$="__forms"] shopify-forms-embed, .shopify-section[id$="__forms"] [data-forms-id="forms-root-814980"] shopify-forms-embed, .shopify-section[id$="__forms"] [data-forms-id="forms-root-805875"] shopify-forms-embed').forEach(polishForm);
    };

    polishAll();
    window.addEventListener('load', polishAll, { once: true });
    setTimeout(polishAll, 400);
    setTimeout(polishAll, 1200);
    setTimeout(polishAll, 2500);

    const observer = new MutationObserver(polishAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-home-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const books = document.querySelectorAll('[data-fec-home-book]:not(.is-enhanced)');

    books.forEach((book) => {
      const leaves = [...book.querySelectorAll('[data-book-leaf]')];
      const previous = book.querySelector('[data-book-previous]');
      const next = book.querySelector('[data-book-next]');
      const status = book.querySelector('[data-book-status]');
      const dots = [...book.querySelectorAll('[data-book-dot]')];
      const stage = book.querySelector('[data-book-stage]');
      const chapterLabel = status.textContent.trim().split(' ')[0];
      let page = 0;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let isAnimating = false;

      const update = () => {
        leaves.forEach((leaf, index) => {
          const isTurned = index < page;
          leaf.classList.toggle('is-turned', isTurned);
          leaf.style.zIndex = isTurned ? index + 1 : leaves.length - index;
          leaf.setAttribute('aria-hidden', index === page ? 'false' : 'true');
        });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === page));
        previous.disabled = isAnimating || page === 0;
        next.disabled = isAnimating || page === leaves.length - 1;
        status.textContent = `${chapterLabel} ${page + 1} of ${leaves.length}`;
      };

      const goTo = (nextPage) => {
        const destination = Math.max(0, Math.min(leaves.length - 1, nextPage));
        if (destination === page || isAnimating) return;
        isAnimating = true;
        book.setAttribute('aria-busy', 'true');
        book.classList.add('is-turning');
        page = destination;
        update();
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 20 : 920;
        window.setTimeout(() => {
          isAnimating = false;
          book.removeAttribute('aria-busy');
          book.classList.remove('is-turning');
          update();
        }, duration);
      };

      previous.addEventListener('click', () => goTo(page - 1));
      next.addEventListener('click', () => goTo(page + 1));
      stage.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });
      stage.addEventListener('pointerup', (event) => {
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;
        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        goTo(deltaX < 0 ? page + 1 : page - 1);
      });
      book.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') goTo(page - 1);
        if (event.key === 'ArrowRight') goTo(page + 1);
      });

      book.classList.add('is-enhanced');
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-home-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fec-home-reviews]').forEach((root) => {
    const source = root.querySelector('[data-fec-review-source]')
    const composition = root.querySelector('[data-fec-review-composition]')
    const leadSlot = root.querySelector('[data-fec-review-lead]')
    const supportSlot = root.querySelector('[data-fec-review-support]')
    const fallback = root.querySelector('[data-fec-review-fallback]')
    if (!source || !composition || !leadSlot || !supportSlot || !fallback) return

    const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim()

    const reviewFromItem = (item) => {
      const body = normalize(item.querySelector('.jdgm-carousel-item__review-body')?.textContent)
      if (body.length < 35) return null

      return {
        id: item.dataset.reviewId || normalize(item.textContent),
        body,
        reviewer: normalize(item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent),
        product: normalize(item.querySelector('.jdgm-carousel-item__product-title')?.textContent)
      }
    }

    const appendAttribution = (container, review) => {
      if (!review.reviewer && !review.product) return
      const attribution = document.createElement('footer')
      attribution.className = 'fec-home-reviews__attribution'

      if (review.reviewer) {
        const reviewer = document.createElement('strong')
        reviewer.textContent = review.reviewer
        attribution.append(reviewer)
      }

      if (review.product) {
        const product = document.createElement('span')
        product.textContent = review.product
        attribution.append(product)
      }

      container.append(attribution)
    }

    const makeQuote = (review, className) => {
      const article = document.createElement('article')
      if (className) article.className = className
      const quote = document.createElement('blockquote')
      quote.textContent = review.body
      article.append(quote)
      appendAttribution(article, review)
      return article
    }

    const prepare = () => {
      const seen = new Set()
      const reviews = [...source.querySelectorAll('.jdgm-carousel-item')]
        .map(reviewFromItem)
        .filter((review) => {
          if (!review || seen.has(review.id)) return false
          seen.add(review.id)
          return true
        })

      if (!reviews.length) return false

      const ordered = [...reviews].sort((a, b) => b.body.length - a.body.length)
      const lead = ordered[0]
      const supporting = ordered.slice(1).sort((a, b) => a.body.length - b.body.length).slice(0, 2)
      const leadQuote = document.createElement('blockquote')
      leadQuote.textContent = lead.body
      leadSlot.replaceChildren(leadQuote)
      appendAttribution(leadSlot, lead)

      supportSlot.replaceChildren(...supporting.map((review) => makeQuote(review, 'fec-home-reviews__support-note')))
      root.querySelector('.fec-home-reviews__support').hidden = supporting.length === 0
      fallback.hidden = true
      composition.hidden = false
      return true
    }

    if (!prepare()) {
      let attempts = 0
      const retry = () => {
        attempts += 1
        if (prepare() || attempts >= 24) return
        window.setTimeout(retry, 250)
      }
      window.setTimeout(retry, 150)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-home-ritual-luminous"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fec-rl-builder]').forEach((form) => {
    const todayQuantity = form.querySelector('[data-fec-rl-today-quantity]')
    const laterQuantity = form.querySelector('[data-fec-rl-later-quantity]')
    const laterRow = form.querySelector('[data-fec-rl-later]')
    const frequency = form.querySelector('[data-fec-rl-frequency]')

    const sync = () => {
      const boxes = form.querySelector('[name="plan_boxes"]:checked')?.value || '2'
      const purchase = form.querySelector('[name="plan_purchase"]:checked')?.value || 'subscribe'
      const boxLabel = `${boxes} High Lady refill ${boxes === '1' ? 'box' : 'boxes'}`
      if (todayQuantity) todayQuantity.textContent = boxLabel
      if (laterQuantity) laterQuantity.textContent = `${boxes} refill ${boxes === '1' ? 'box' : 'boxes'}`
      if (laterRow) laterRow.classList.toggle('is-hidden', purchase !== 'subscribe')
      if (frequency) frequency.disabled = purchase !== 'subscribe'
    }

    form.addEventListener('change', sync)
    form.addEventListener('submit', (event) => {
      event.preventDefault()
      const params = new URLSearchParams(new FormData(form))
      window.location.assign(`/pages/shop?${params.toString()}#detergent-builder`)
    })
    sync()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-paid-landing-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var pages = document.querySelectorAll('.fec-paid-landing');
    if (!pages.length) return;

    var currentParams = new URLSearchParams(window.location.search);
    var preserved = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

    pages.forEach(function(page) {
      page.querySelectorAll('a[href]').forEach(function(link) {
        try {
          var url = new URL(link.getAttribute('href'), window.location.origin);
          if (url.origin !== window.location.origin) return;
          preserved.forEach(function(key) {
            if (currentParams.has(key) && !url.searchParams.has(key)) {
              url.searchParams.set(key, currentParams.get(key));
            }
          });
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (error) {
          return;
        }
      });
    });

    var toggleSticky = function() {
      pages.forEach(function(page) {
        page.classList.toggle('is-scrolled', window.scrollY > 360);
      });
    };
    toggleSticky();
    window.addEventListener('scroll', toggleSticky, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-plan-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cadenceMonths = { '1m': 1, '2m': 2, '3m': 3 };
    const cadenceLabels = { '1m': 'month', '2m': '2 months', '3m': '3 months' };

    document.querySelectorAll('[data-fec-plan-finder]').forEach((finder) => {
      const panel = finder.querySelector('[data-fec-plan-panel]');
      const loadsPerBox = Number(panel?.dataset.loadsPerBox || 35);
      const title = finder.querySelector('[data-fec-plan-title]');
      const copy = finder.querySelector('[data-fec-plan-copy]');
      const cta = finder.querySelector('[data-fec-plan-cta]');
      const checked = (part) => finder.querySelector(`input[name*="${part}"]:checked`)?.value;

      function choosePlan(loadsPerWeek, desiredCadence) {
        const cadences = desiredCadence === 'auto'
          ? (loadsPerWeek <= 3 ? ['2m', '1m', '3m'] : loadsPerWeek <= 8 ? ['3m', '2m', '1m'] : ['2m', '1m', '3m'])
          : [desiredCadence];
        for (const cadence of cadences) {
          const requiredLoads = Math.ceil(loadsPerWeek * 4.33 * cadenceMonths[cadence]);
          const boxes = Math.min(3, Math.max(1, Math.ceil(requiredLoads / loadsPerBox)));
          if (requiredLoads <= boxes * loadsPerBox) return { boxes, cadence, requiredLoads };
        }
        return { boxes: 3, cadence: '1m', requiredLoads: Math.ceil(loadsPerWeek * 4.33) };
      }

      function update() {
        const loadsPerWeek = Math.max(Number(checked('loads') || 5), Math.ceil(Number(checked('household') || 2) * 1.25));
        const cadenceChoice = checked('cadence') || 'auto';
        const plan = choosePlan(loadsPerWeek, cadenceChoice);
        const boxWord = plan.boxes === 1 ? 'box' : 'boxes';
        title.textContent = `${plan.boxes} ${boxWord} every ${cadenceLabels[plan.cadence]}`;
        copy.textContent = plan.cadence === '3m'
          ? 'A low-maintenance refill rhythm for households that want detergent to quietly stay handled.'
          : plan.cadence === '2m'
            ? 'A balanced refill rhythm for steady weekly laundry without overstocking.'
            : 'A higher-use rhythm for busy laundry weeks, larger households, or fewer surprises.';
        const href = `/pages/shop?plan_boxes=${plan.boxes}&plan_frequency=${plan.cadence}#shop-top`;
        cta.setAttribute('href', href);
        cta.textContent = 'Shop this plan';
        cta.dataset.boxes = String(plan.boxes);
        cta.dataset.frequency = plan.cadence;
      }

      finder.addEventListener('change', update);
      cta?.addEventListener('click', (event) => {
        const form = document.querySelector('[data-fec-shop-form]');
        if (!form) return;
        event.preventDefault();
        const detail = { boxes: cta.dataset.boxes, frequency: cta.dataset.frequency };
        document.dispatchEvent(new CustomEvent('fec:select-plan', { detail }));
        document.querySelector('#shop-top')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fec-ugc-feed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFeed = (root) => {
      if (!root || root.dataset.fecUgcReady === 'true') return
      root.dataset.fecUgcReady = 'true'

      const rail = root.querySelector('[data-fec-ugc-rail]')
      const previous = root.querySelector('[data-fec-ugc-previous]')
      const next = root.querySelector('[data-fec-ugc-next]')
      const cards = [...root.querySelectorAll('[data-fec-ugc-card]')]
      if (!rail || !cards.length) return

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      let activeIndex = 0
      let scrollFrame = 0

      const centerCard = (index, behavior = reducedMotion.matches ? 'auto' : 'smooth') => {
        const card = cards[index]
        if (!card) return
        const left = card.offsetLeft - ((rail.clientWidth - card.offsetWidth) / 2)
        rail.scrollTo({ left: Math.max(0, left), behavior })
      }

      const pauseCard = (card) => {
        const video = card.querySelector('[data-fec-ugc-video]')
        const play = card.querySelector('[data-fec-ugc-play]')
        if (!video) return
        video.pause()
        video.controls = false
        video.tabIndex = -1
        if (play) {
          play.classList.remove('is-hidden')
          play.tabIndex = -1
        }
      }

      const setActive = (index, options = {}) => {
        const nextIndex = Math.max(0, Math.min(cards.length - 1, index))
        activeIndex = nextIndex

        cards.forEach((card, cardIndex) => {
          const distance = cardIndex - activeIndex
          const isActive = distance === 0
          const isNear = Math.abs(distance) === 1
          const video = card.querySelector('[data-fec-ugc-video]')
          const play = card.querySelector('[data-fec-ugc-play]')

          card.classList.toggle('is-active', isActive)
          card.classList.toggle('is-near', isNear)
          card.classList.toggle('is-before', distance < 0)
          card.classList.toggle('is-after', distance > 0)
          card.setAttribute('aria-current', isActive ? 'true' : 'false')

          if (!isActive) {
            pauseCard(card)
          } else if (video) {
            video.controls = true
            video.tabIndex = 0
            if (play) play.tabIndex = 0
          }
        })

        if (previous) previous.disabled = activeIndex === 0
        if (next) next.disabled = activeIndex === cards.length - 1
        if (options.scroll !== false) centerCard(activeIndex)
        if (options.focus === true) cards[activeIndex].focus({ preventScroll: true })
      }

      cards.forEach((card, index) => {
        const video = card.querySelector('[data-fec-ugc-video]')
        const play = card.querySelector('[data-fec-ugc-play]')

        card.addEventListener('click', (event) => {
          if (index === activeIndex) return
          event.preventDefault()
          event.stopPropagation()
          setActive(index)
        }, true)

        card.addEventListener('keydown', (event) => {
          if (event.target !== card) return
          if (event.key === 'ArrowLeft') {
            event.preventDefault()
            setActive(activeIndex - 1, { focus: true })
          } else if (event.key === 'ArrowRight') {
            event.preventDefault()
            setActive(activeIndex + 1, { focus: true })
          } else if (event.key === 'Home') {
            event.preventDefault()
            setActive(0, { focus: true })
          } else if (event.key === 'End') {
            event.preventDefault()
            setActive(cards.length - 1, { focus: true })
          } else if (index !== activeIndex && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault()
            setActive(index, { focus: true })
          }
        })

        if (!video || !play) return
        play.addEventListener('click', async (event) => {
          event.stopPropagation()
          if (index !== activeIndex) {
            setActive(index)
            return
          }
          cards.forEach((otherCard, otherIndex) => {
            if (otherIndex !== activeIndex) pauseCard(otherCard)
          })
          video.muted = false
          try {
            await video.play()
          } catch (_) {
            video.muted = true
            await video.play().catch(() => {})
          }
        })
        video.addEventListener('play', () => {
          if (index !== activeIndex) {
            video.pause()
            return
          }
          cards.forEach((otherCard, otherIndex) => {
            if (otherIndex !== activeIndex) pauseCard(otherCard)
          })
          play.classList.add('is-hidden')
        })
        video.addEventListener('pause', () => play.classList.remove('is-hidden'))
        video.addEventListener('ended', () => play.classList.remove('is-hidden'))
      })

      previous?.addEventListener('click', () => setActive(activeIndex - 1, { focus: true }))
      next?.addEventListener('click', () => setActive(activeIndex + 1, { focus: true }))

      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail) return
        if (event.key === 'ArrowLeft') {
          event.preventDefault()
          setActive(activeIndex - 1)
        } else if (event.key === 'ArrowRight') {
          event.preventDefault()
          setActive(activeIndex + 1)
        } else if (event.key === 'Home') {
          event.preventDefault()
          setActive(0)
        } else if (event.key === 'End') {
          event.preventDefault()
          setActive(cards.length - 1)
        }
      })

      rail.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame)
        scrollFrame = requestAnimationFrame(() => {
          const railCenter = rail.getBoundingClientRect().left + (rail.clientWidth / 2)
          let nearestIndex = activeIndex
          let nearestDistance = Number.POSITIVE_INFINITY
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect()
            const distance = Math.abs((rect.left + (rect.width / 2)) - railCenter)
            if (distance < nearestDistance) {
              nearestDistance = distance
              nearestIndex = index
            }
          })
          if (nearestIndex !== activeIndex) setActive(nearestIndex, { scroll: false })
        })
      }, { passive: true })

      let resizeTimer
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer)
        resizeTimer = window.setTimeout(() => centerCard(activeIndex, 'auto'), 120)
      })

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => !entry.isIntersecting)) {
            cards.forEach((card) => {
              const video = card.querySelector('[data-fec-ugc-video]')
              if (video) video.pause()
            })
          }
        }, { threshold: 0.08 })
        observer.observe(root)
      }

      setActive(0, { scroll: false })
      requestAnimationFrame(() => centerCard(0, 'auto'))
    }

    document.querySelectorAll('[data-fec-ugc-feed]').forEach(initFeed)
    document.addEventListener('shopify:section:load', (event) => {
      initFeed(event.target.querySelector('[data-fec-ugc-feed]'))
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
